var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocNavy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8063 0.879C35.236 0.315 34.4582 0 33.65 0H3.14998C1.46638 0 0.0999756 1.344 0.0999756 3V57C0.0999756 58.656 1.46638 60 3.14998 60H45.85C47.5336 60 48.9 58.656 48.9 57V15C48.9 14.205 48.5797 13.44 48.0063 12.879L35.8063 0.879ZM42.8 54H6.19998V6H32.3873L42.8 16.242V54Z",
    fill: "#2C6085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocNavy);
export default __webpack_public_path__ + "static/media/doc-navy.d4928cb52e87d3eb3a82503eae96e573.svg";
export { ForwardRef as ReactComponent };